module.exports = __webpack_public_path__ + "static/ideas-74708958b7e86991f96cb262cb000a0a.png";